"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskList = void 0;
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const react_i18next_1 = require("react-i18next");
const Breadcrumbs_1 = require("@amzn/atoz-web/Breadcrumbs");
const View_1 = require("@amzn/atoz-web/View");
const Card_1 = require("@amzn/atoz-web/Card");
const Col_1 = require("@amzn/atoz-web/Col");
const Hr_1 = require("@amzn/atoz-web/Hr");
const Modal_1 = require("@amzn/atoz-web/Modal");
const Text_1 = require("@amzn/atoz-web/Text");
const Theme_1 = require("@amzn/atoz-web/Theme");
const Icons_1 = require("@amzn/atoz-web/Icons");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const types_1 = require("../../types");
const consts_1 = require("../../consts");
const logger_1 = require("../../logger");
const components_1 = require("../../components");
const TaskListTypes_1 = require("./TaskListTypes");
const TaskItem_1 = require("../TaskItem");
const hooks_1 = require("./hooks");
const taskListUtils_1 = require("./utils/taskListUtils");
const task_list_desktop_svg_1 = __importDefault(require("../../assets/images/task-list-desktop.svg"));
const TaskListDescription_1 = require("../TaskListDescription");
const BIAnalytics_1 = require("../../utils/BIAnalytics/BIAnalytics");
const fetchUtils_1 = require("../../client/fetchUtils");
const TaskList = ({ taskListGroups = [], currentPayPeriod, isAnomalySearchEnabled }) => {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)();
    const { clientName, associateInfo, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    const isNonProdEnv = currentStage !== fetchUtils_1.Stage.PROD;
    const { title, addressBeforeMessage, description, descriptionTitle, descriptionFull, isEmpty, requireAttentionRenderUtils } = (0, hooks_1.useTaskList)({
        taskListGroups,
        currentPayPeriod
    });
    const { clickedPunchCorrStatus, setClickedId } = (0, hooks_1.useGetClickedPunchCorrStatus)(taskListGroups);
    const renderTaskListEmptyState = () => (react_1.default.createElement(StyledCard, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TASK_LIST_EMPTY_STATE },
        react_1.default.createElement(StyledImg, { src: task_list_desktop_svg_1.default, alt: 'Required, pending approval or accepted tasks' })));
    const renderRequireAttentionItems = (requireAttentionGroup) => {
        if (requireAttentionGroup.key !== types_1.TaskListTypes.RequireAttention) {
            return null;
        }
        const { duplicatedPunches = [], missingPunches = [], systemAddedPunches = [], requireAttentionItems = [] } = requireAttentionGroup;
        const renderRequireAttentionItemGroup = (group) => {
            const { punchTypeTitleMap, anomalyTypeMap, formatSubtitle, formatTaskItemAriaLabel } = requireAttentionRenderUtils;
            const redirectToTimecardWithDate = (dateTimeString, anomalyType) => {
                var _a, _b, _c;
                let metricName = '';
                if (anomalyType === types_1.TaskListAnomalyTypes.DuplicatePunch) {
                    (_a = BIAnalytics_1.BIAnalytics.clickDuplicatedPunch) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
                    metricName = logger_1.METRICS.TASK_LIST_DUPLICATE_PUNCH_CLICK.COUNT;
                }
                else if (anomalyType === types_1.TaskListAnomalyTypes.MissingPunch) {
                    (_b = BIAnalytics_1.BIAnalytics.clickMissingPunch) === null || _b === void 0 ? void 0 : _b.call(BIAnalytics_1.BIAnalytics);
                    metricName = logger_1.METRICS.TASK_LIST_MISSING_PUNCH_CLICK.COUNT;
                }
                else if (anomalyType === types_1.TaskListAnomalyTypes.SystemAddedPunch) {
                    (_c = BIAnalytics_1.BIAnalytics.clickSystemAddedPunch) === null || _c === void 0 ? void 0 : _c.call(BIAnalytics_1.BIAnalytics);
                    metricName = logger_1.METRICS.TASK_LIST_SYSTEM_ADDED_PUNCH_CLICK.COUNT;
                }
                if (metricName) {
                    logger_1.logger.emitCountMetric({
                        metricName,
                        dimensions
                    });
                }
                const path = `${consts_1.ATOZ_FEATURE_PATH.TIME_CARD}?date=${luxon_1.DateTime.fromISO(dateTimeString).toISODate()}`;
                location.assign(path);
            };
            const RightChevronButton = () => (react_1.default.createElement(IconButton, { "data-test-id": TaskListTypes_1.DATA_TEST_IDS.TLI_RA_ITEM_CARD_ACTION_BUTTON, "aria-label": t('time_and_attendance_TaskList_ListItemButton_AccessibilityLabel_Edit') },
                react_1.default.createElement(Icons_1.IconChevronRight, { color: "primary70" })));
            return group.map(({ dateTimeString, punchType, anomalyType }, index) => (react_1.default.createElement(react_1.default.Fragment, { key: `${dateTimeString}-${anomalyType}-${index}` },
                react_1.default.createElement(TaskListItemCard, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TLI_RA_ITEM_CARD, margin: { top: 'S200', bottom: 'S200' }, onClick: () => redirectToTimecardWithDate(dateTimeString, anomalyType) },
                    react_1.default.createElement(TaskItem_1.TaskItem, { chipText: isAnomalySearchEnabled
                            ? t('time_and_attendance_TaskList_RequiredAttention')
                            : anomalyTypeMap[anomalyType], chipBgColor: "red", renderChipIcon: () => (react_1.default.createElement(Icons_1.IconAlertCircleFill, { size: Icons_1.IconSize.ExtraSmall, color: "red70" })), title: isAnomalySearchEnabled
                            ? anomalyTypeMap[anomalyType]
                            : punchTypeTitleMap[punchType], subTitle: formatSubtitle(dateTimeString, anomalyType === types_1.TaskListAnomalyTypes.MissingPunch), ariaLabel: formatTaskItemAriaLabel(anomalyTypeMap[anomalyType], punchType, dateTimeString, anomalyType === types_1.TaskListAnomalyTypes.MissingPunch
                            ? luxon_1.DateTime.DATE_MED
                            : luxon_1.DateTime.DATETIME_MED), renderIconButton: () => react_1.default.createElement(RightChevronButton, null) })),
                react_1.default.createElement(Hr_1.Hr, null))));
        };
        return (react_1.default.createElement(View_1.View, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TASK_LIST_ITEMS_REQUIRE_ATTENTION }, isAnomalySearchEnabled ? (react_1.default.createElement(View_1.View, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TLI_RA_ITEMS }, renderRequireAttentionItemGroup(requireAttentionItems))) : (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(View_1.View, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TLI_RA_DUPLICATED_PUNCHES }, renderRequireAttentionItemGroup(duplicatedPunches)),
            react_1.default.createElement(View_1.View, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TLI_RA_MISSING_PUNCHES }, renderRequireAttentionItemGroup(missingPunches)),
            react_1.default.createElement(View_1.View, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TLI_RA_SYSTEM_ADDED_PUNCHES }, renderRequireAttentionItemGroup(systemAddedPunches))))));
    };
    const renderPunchCorrStatus = (taskListGroup) => {
        const showStatusDetails = (requestId, taskListType) => {
            var _a, _b, _c;
            let metricName = '';
            if (taskListType === types_1.TaskListTypes.RequireAttention) {
                (_a = BIAnalytics_1.BIAnalytics.clickNotAcceptedRequest) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
                metricName =
                    logger_1.METRICS.TASK_LIST_PUNCH_STATUS_CORRECTION_NOT_ACCEPTED_CLICK.COUNT;
            }
            else if (taskListType === types_1.TaskListTypes.PendingRequest) {
                (_b = BIAnalytics_1.BIAnalytics.clickPendingRequest) === null || _b === void 0 ? void 0 : _b.call(BIAnalytics_1.BIAnalytics);
                metricName =
                    logger_1.METRICS.TASK_LIST_PUNCH_STATUS_CORRECTION_PENDING_CLICK.COUNT;
            }
            else if (taskListType === types_1.TaskListTypes.CompletedRequest) {
                (_c = BIAnalytics_1.BIAnalytics.clickAcceptedRequest) === null || _c === void 0 ? void 0 : _c.call(BIAnalytics_1.BIAnalytics);
                metricName =
                    logger_1.METRICS.TASK_LIST_PUNCH_STATUS_CORRECTION_COMPLETED_CLICK.COUNT;
            }
            if (metricName) {
                logger_1.logger.emitCountMetric({
                    metricName,
                    dimensions
                });
            }
            setClickedId(requestId);
        };
        return taskListGroup.punchCorrectionStatus.map((punchCorrectionStatus) => {
            const { dateTime, initialDateTime } = (0, taskListUtils_1.getPunchDateTime)(punchCorrectionStatus);
            return (react_1.default.createElement(react_1.Fragment, { key: `${taskListGroup.key}-${punchCorrectionStatus.requestId}` },
                react_1.default.createElement(TaskListItemCard, { margin: { top: 'S200', bottom: 'S200' }, onClick: () => showStatusDetails(punchCorrectionStatus.requestId, taskListGroup.key), dataTestId: TaskListTypes_1.DATA_TEST_IDS.TLI_PCA_ITEM_CARD },
                    react_1.default.createElement(components_1.StatusOverview, { type: punchCorrectionStatus.requestType, status: punchCorrectionStatus.status, reason: punchCorrectionStatus.reasonCode, canRenderRequestReviewButton: isNonProdEnv, dateTime: dateTime, initialDateTime: initialDateTime, isInTaskList: true })),
                react_1.default.createElement(Hr_1.Hr, null)));
        });
    };
    const renderTaskListItems = () => (react_1.default.createElement(Col_1.Col, { dataTestId: "TaskListItems" },
        react_1.default.createElement(Hr_1.Hr, null),
        taskListGroups.map((taskListGroup, index) => (react_1.default.createElement(react_1.Fragment, { key: `${taskListGroup.key}-${index}` }, isAnomalySearchEnabled ? (react_1.default.createElement(react_1.Fragment, null,
            renderRequireAttentionItems(taskListGroup),
            renderPunchCorrStatus(taskListGroup))) : (react_1.default.createElement(react_1.Fragment, null,
            renderPunchCorrStatus(taskListGroup),
            renderRequireAttentionItems(taskListGroup))))))));
    const closePunchCorrStatusModal = () => {
        var _a;
        (_a = BIAnalytics_1.BIAnalytics.PCSModalCloseModal) === null || _a === void 0 ? void 0 : _a.call(BIAnalytics_1.BIAnalytics);
        logger_1.logger.emitCountMetric({
            metricName: logger_1.METRICS.TASK_LIST_CLOSE_PUNCH_CORRECTION_STATUS_MODAL.COUNT,
            dimensions
        });
        setClickedId(null);
    };
    const breadcrumbs = [
        {
            title: t('time_and_attendance_Timecard_TimecardTitle_Timecard'),
            url: consts_1.ATOZ_FEATURE_PATH.TIME_CARD
        },
        {
            title: t('time_and_attendance_TaskList_Title'),
            url: '#'
        }
    ];
    const onCrumbClick = (e, crumb) => {
        if (crumb.url === breadcrumbs[0].url) {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.TASK_LIST_BACK_TIMECARD_CLICK.COUNT,
                dimensions
            });
        }
    };
    return (react_1.default.createElement(View_1.View, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TASK_LIST },
        react_1.default.createElement(StyledCard, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TASK_LIST_HEADER },
            react_1.default.createElement(Breadcrumbs_1.Breadcrumbs, { crumbs: breadcrumbs, onCrumbClick: onCrumbClick }),
            react_1.default.createElement(Text_1.H2, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TASK_LIST_TITLE, fontSize: 'T400' },
                react_1.default.createElement("strong", null, title)),
            react_1.default.createElement(TaskListDescription_1.TaskListDescription, { description: description, descriptionTitle: descriptionTitle, descriptionFull: descriptionFull }),
            !!((_a = taskListGroups[0]) === null || _a === void 0 ? void 0 : _a.count) && !!addressBeforeMessage && (react_1.default.createElement(Text_1.Text, { color: "neutral70", dataTestId: TaskListTypes_1.DATA_TEST_IDS.TASK_LIST_ADDRESS_BEFORE, fontSize: 'T200', margin: { top: 'S300' } }, addressBeforeMessage))),
        react_1.default.createElement(View_1.View, { dataTestId: TaskListTypes_1.DATA_TEST_IDS.TASK_LIST_ITEMS, margin: { top: 'S400' } }, isEmpty() ? renderTaskListEmptyState() : renderTaskListItems()),
        react_1.default.createElement(Modal_1.Modal, { isOpen: !!clickedPunchCorrStatus, close: closePunchCorrStatusModal }, !!clickedPunchCorrStatus && (react_1.default.createElement(components_1.PunchStatusModal, { employeeId: associateInfo.employeeId, status: clickedPunchCorrStatus.status, reason: clickedPunchCorrStatus.reasonCode, type: clickedPunchCorrStatus.requestType, requestId: clickedPunchCorrStatus.requestId, referenceId: clickedPunchCorrStatus.referenceId, dateTime: (0, taskListUtils_1.getPunchDateTime)(clickedPunchCorrStatus).dateTime, initialDateTime: (0, taskListUtils_1.getPunchDateTime)(clickedPunchCorrStatus).initialDateTime, closeModal: closePunchCorrStatusModal, canRenderSubmitReviewRequest: isNonProdEnv })))));
};
exports.TaskList = TaskList;
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
   display:flex;
   flex-direction: column;
   border: none;
`);
const TaskListItemCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(`
  display: flex;
  flex-direction: column;
  border: none;
  cursor: pointer;
`);
const IconButton = (0, Theme_1.styledWithTheme)('button')(({ theme }) => `
    background-color: transparent;
    border: 2px solid transparent;
    border-radius: 50%;
    padding: 6px;

    &:hover {
      cursor: pointer;
      border-color: ${theme.selectors.color('primary70')};
    }

    &:focus-visible {
      border-color: ${theme.selectors.color('primary70')};
    }
  `);
const StyledImg = (0, Theme_1.styledWithTheme)('img')(`
   max-width: 600px;
`);
